import { useAuthStore } from "~/stores/AuthStore";
import { useHistoryStore } from "~/stores/HistoryStore";

// ログイン画面にリダイレクトするかどうかを設定する
// 新規登録画面にリダイレクトしたい場合にはshouldRedirectToRegisterをtrueにする
// definePageMeta({
//   shouldRedirectToRegister: true,
//   middleware: ["auth"],
// });

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const authStore = useAuthStore();
  const historyStore = useHistoryStore();
  await authStore.checkAuthState();
  if (!authStore.token) {
    const redirectTo = to.meta.shouldRedirectToRegister ? "register" : "login";
    return historyStore.to(`/${redirectTo}?returnPath=${encodeURIComponent(to.fullPath)}`);
  }
});
